module.exports = __webpack_public_path__ + "media/Man_Chat_3.019130a0.mp3";